/** An action the notification offers, rendered as a link in the toast. */

export const NOTIFICATION_SEND = 'NOTIFICATION_SEND';
export const NOTIFICATION_UPDATE = 'NOTIFICATION_UPDATE';
export const NOTIFICATION_DISMISS = 'NOTIFICATION_DISMISS';
export const NOTIFICATIONS_CLEAR = 'NOTIFICATION_CLEAR';
function addNotification(notification) {
  return {
    type: NOTIFICATION_SEND,
    payload: notification
  };
}

/**
 * Changes a notification on screen instead of stacking a new one. A no-op for
 * an unknown id, e.g. a toast the user already dismissed.
 */
function updateNotification(id, notification) {
  return {
    type: NOTIFICATION_UPDATE,
    id,
    payload: notification
  };
}
function dismissNotification(id) {
  return {
    type: NOTIFICATION_DISMISS,
    id
  };
}
function clearNotifications() {
  return {
    type: NOTIFICATIONS_CLEAR
  };
}
export { addNotification, updateNotification, dismissNotification, clearNotifications };